import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, checkInitStatus } from '../services/api';
import { setToken } from '../utils/auth';
import { useI18n } from '../i18n/I18nContext';
import styles from './Login.module.css';

function Login() {
  const { t } = useI18n();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [initStatus, setInitStatus] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    // 檢查系統初始化狀態
    checkInitStatus()
      .then(data => {
        setInitStatus(data);
        if (!data.has_admin) {
          setError(t('login.error_no_admin'));
        }
      })
      .catch(err => {
        console.error('檢查初始化狀態失敗:', err);
      });
  }, [t]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await login(username, password);
      const { token, password_reset_required } = response.data;

      setToken(token);

      if (password_reset_required) {
        navigate('/change-password');
      } else {
        navigate('/chat');
      }
    } catch (err) {
      const errorMessage = err.response?.data?.error || t('login.default_error');
      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.loginContainer}>
      <div className={styles.loginBox}>
        <h1>{t('login.title')}</h1>
        <h2>{t('login.subtitle')}</h2>
        
        {initStatus && !initStatus.has_admin && (
          <div className={styles.errorMessage}>
            {t('login.error_no_admin_box')}
          </div>
        )}

        {error && <div className={styles.errorMessage}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label htmlFor="username">{t('login.label_username')}</label>
            <input
              type="text"
              id="username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
              disabled={loading || (initStatus && !initStatus.has_admin)}
            />
          </div>

          <div className={styles.formGroup}>
            <label htmlFor="password">{t('login.label_password')}</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading || (initStatus && !initStatus.has_admin)}
            />
          </div>

          <button
            type="submit"
            className={styles.submitButton}
            disabled={loading || (initStatus && !initStatus.has_admin)}
          >
            {loading ? t('login.submit_loading') : t('login.submit')}
          </button>
        </form>
      </div>
    </div>
  );
}

export default Login;
